module.exports = __webpack_public_path__ + "static/media/class_job_019.671da48f.svg";